import i18n from '@/locale/index'

export default [
  {
    path: '/paradise',
    name: 'paradise',
    component: () => import('../../views/paradise/index.vue'),
    meta: {
      title: i18n.global.t('points.c5_1'),
      pageKey: 'Task_Paradise_home'
    }
  },
  {
    path: '/loading',
    name: 'loading',
    component: () => import('../../views/paradise/load.vue'),
    meta: {
      title: i18n.global.t('points.c5')
    }
  },
  {
    path: '/tasklist',
    name: 'tasklist',
    component: () => import('../../views/paradise/list.vue'),
    meta: {
      title: i18n.global.t('points.c20')
    }
  }
]
